// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1Pdyo","button":"styles_button__34Ouw","cancel":"styles_cancel__sWYPN"};